import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
import { createComponent } from '../utils';
export var Icon = createComponent({
    name: 'Icon',
    tag: 'i',
    props: function (_a) {
        var name = _a.name;
        return ({
            className: "mdi mdi-" + name,
        });
    },
    style: function (_a) {
        var theme = _a.theme, size = _a.size, color = _a.color, disabled = _a.disabled, onClick = _a.onClick;
        var colorFromTheme = color ? theme.colors[color] : '';
        var resolvedColor = colorFromTheme || color;
        return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n      font-size: ", ";\n\n      ", ";\n\n      ", "\n    "], ["\n      color: ", ";\n      font-size: ", ";\n\n      ",
            ";\n\n      ",
            "\n    "])), resolvedColor || 'inherit', size ? size + "px" : 'inherit', disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        pointer-events: none;\n        opacity: 0.65;\n      "], ["\n        pointer-events: none;\n        opacity: 0.65;\n      "]))), onClick && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        cursor: pointer;\n      "], ["\n        cursor: pointer;\n      "]))));
    },
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Icon.js.map